export default {
    login: {
        new: {
            title: "Nouveautés dans notre boutique",
            description: "Accédez à notre boutique en tant que client en entrant les informations ci-dessous.",
            form: {
                field1: "FedEx Ground ID",
                field2: "Numéro De Contrat"
            }
        },
        existing: {
            title: "Déjà client",
            description: "Bienvenue à nouveau. Veuillez vous inscrire avec vos justificatifs d'identité.",
            form: {
                field1: "Adresse",
                field2: "Mot de passe"
            }
        },
        links: {
            forgotPassword: "Mot De Passe Oublié?",
            assistance: "Besoin d'aide?",
            privacy: "Déclaration De Confidentialité"
        },
        or: "OU",
        btn: "Connecter"
    },
    passwordRecovery: {
        title: "Récupération Du Mot De Passe",
        description: "Pour réinitialiser votre mot de passe, vérifiez l'adresse électronique que vous utilisez pour vous connecter",
        form: {
            field1: "Adresse"
        },
        success: {
            title: "Réinitialiser Le Mot De Passe Courriel Envoyé",
            description: "Veuillez vérifier votre courriel pour réinitialiser votre mot de passe."
        },
        btn: "Envoyer",
        back: "Revenir À La Connexion"
    },
    passwordReset: {
        title: "Récupération Du Mot De Passe",
        description: "Saisissez et confirmez votre nouveau mot de passe dans le formulaire ci-dessous",
        form: {
            field1: "Nouveau Mot De Passe",
            field2: "Confirmer Le Nouveau Mot De Passe"
        },
        success: {
            title: "Votre mot de passe a été changé"
        },
        btn: "Recover",
        back: "Revenir À La Connexion"
    },
    navMenu: {
        logout: "Connectez - Out"
    },
    home: {
        tabName: "Accueil",
        title: "Bienvenue dans la boutique Velocitor",
        cspBlock: {
            description: "Profitez d'une expérience de magasinage rapide et facile en regroupant l'équipement et les services nécessaires dans des kits.",
            shopKitsBtn: "Kits d'atelier",
            buildAKitBtn: "Construire un kit"
        },
        vTrackBlock: {
            header: "Solution de flotte V-Track",
            description: "En savoir plus sur la solution technologique et de gestion de flotte mobile de Velocitor."
        },
        devicesBlock: {
            description: "Quel appareil vous convient le mieux?",
            compare: "Comparer les appareils"
        },
        categories: {
            devices: {
                description: "Nous avons Panasonic et Zebra"
            },
            zebra: {
                description: "Nous avons une gamme complète d'accessoires Zebra"
            },
            panasonic: {
                description: "Nous offrons une gamme complète d'accessoires Panasonic"
            }
        }
    },
    devices: {
        title: "Devices",
        wizard: {
            steps: {
                one: {
                    title: "Devices",
                    message: "Veuillez choisir un appareil."
                },
                two: {
                    title: "Sans Fil"
                },
                three: {
                    title: "Panier"
                }
            }
        }
    },
    kits: {
        title: "Kits",
        wizard: {
            steps: {
                one: {
                    title: "Kits",
                    message: "Veuillez choisir un appareil pour commencer à construire votre kit."
                },
                two: {
                    title: "Sans fil"
                },
                three: {
                    title: "Panier"
                }
            }
        }
    },
    buildAKit: {
        title: "Construire un kit",
        kitPricingSummary: {
            title: "Résumé du prix du kit",
            devices: "Dispositifs",
            dataPlans: "Plans cellulaires des opérateurs",
            chargingAccessories: "Accessoires de charge",
            optionalAccessories: "Accessoires optionnels",
            totalDue: "Total dû",
            numberOfKits: "Nombre de kits"
        },
        wizard: {
            steps: {
                one: {
                    title: "Choisir un appareil",
                    message: "Veuillez choisir un appareil pour commencer à construire votre kit."
                },
                two: {
                    title: "Choisir un transporteur"
                },
                three: {
                    title: "Sélectionnez les accessoires de charge"
                },
                four: {
                    title: "Sélectionnez les accessoires optionnels"
                }
            }
        },
        chargingAccessories: {
            message: "Nous proposons des options de chargement de véhicule et de maison / bureau. Veuillez choisir l'une des options de charge ci-dessous."
        },
        optionalAccessories: {
            message: "Ces accessoires ne sont pas nécessaires pour votre kit, mais apportent plus de confort et de protection."
        },
        kitProduct: {
            name: "%{name} Kit",
            title: "%{name} comprend:",
            panasonicN1: {
                li1: "Ordinateur portable Panasonic N1 avec batterie",
                li2: "Batterie de rechange gratuite et dragonne",
                li3: "* Services de mise en scène et de mise en kit ainsi qu'un échange préalable de 3 ans requis"
                // li4: "Mise en scène et kitting"
            },
            zebraTc77: {
                li1: "Ordinateur portable Zebra TC-77 avec batterie",
                li2: "Batterie de rechange gratuite et dragonne",
                li3: "* Services de mise en scène et de mise en kit ainsi qu'un échange préalable de 3 ans requis"
                // li4: "Mise en scène et kitting"
            }
        }
    },
    accessories: {
        accessories: "Accessoires",
        title: "Accessoires %{name}"
    },
    relatedProducts: {
        title: "Produits connexes"
    },
    deviceComparison: {
        title: "Comparaison des appareils"
    },
    dataPlans: {
        title: "Souhaitez-vous ajouter un plan de données?",
        message: "Sur la base de l'évaluation par FXG des taux moyens de consommation de données de l'application FORGE, un forfait cellulaire de 3 Go par mois est l'exigence minimale. À mesure que la technologie continue de progresser et que de nouvelles fonctionnalités et fonctions sont déployées, la consommation de données continuera de croître. Les forfaits de données mis à jour sont destinés à prendre en charge toutes les mises à jour des appareils via la connectivité cellulaire. La connexion au réseau Wi-Fi ne sera plus nécessaire pour mettre à jour l'application FORGE ou effectuer toute autre mise à jour de l'appareil.",
        canadaOnly: "Canada seulement",
        overage1: "Excédent: $0,12 par Mo",
        overage2: "Excédent: $11,53 par Go",
        tooltip: "Veuillez faire une sélection de plan de données",
        select: "Sélectionnez le plan",
        select2: "Sélectionnez un forfait de données mensuel",
        modalTitle: "Pas de forfait de données",
        modalText: "Vous choisissez de ne pas avoir de forfait de données associé à votre appareil. Voulez-vous continuer?",
        modalCancel: "Annuler",
        modalContinue: "Continuer"
    },
    orderSummary: {
        title: "Récapitulatif de la commande"
    },
    cart: {
        title: "Panier",
        cartEmpty: "Votre panier est vide!",
        continueShopping: "Continuer vos achats",
        printCart: "Panier d'impression",
        clearCart: "Vider le panier",
        panels: {
            kitsDevices: "Kits / Appareils",
            accessories: "Accessoires",
            services: "Services mensuels récurrents",
            accessoriesMessage: "Vous recherchez des accessoires multi-périphériques, de stockage et autres accessoires utiles? Accédez au menu Accessoires ci-dessus ou cliquez sur l'un des liens ci-dessous pour ajouter des articles directement à votre panier."
        },
        totalDue: "Montant total dû",
        shippingTaxes: "Les frais de livraison et les taxes seront calculés à la caisse",
        payment: {
            title: "Comment voulez-vous payer?",
            customerAlert: {
                station: "Station",
                employeeId: "Numéro d'employé",
                purchaseEligibilityDate: "Date d'admissibilité à l'achat",
                onTheRoadEligibilityDate: "Date d'admissibilité sur la route",
                customMessage: "D'après les enregistrements reçus de FedEx Ground, l'activation de votre station n'a pas encore été programmée. Des vagues supplémentaires débuteront en janvier",
                guestMessage: "Pour enregistrer les articles ajoutés à votre panier",
                createAccount: "créez un compte",
                saveItemsToCart: "We will save the items in your shopping cart for you. Please return to the store on or after your eligibility date to complete your order.",
                needAssistance1: "Si vous avez des questions ou avez besoin d’assistance, veuillez",
                needAssistance2: "contacter",
                needAssistance3: "le Support Velocitor.",
                thankYou: "Je vous remercie."
            },
            options: {
                payInFull: {
                    title: "Payer en entier",
                    desc1: "Paiement unique",
                    desc2: "Services mensuels récurrents",
                    note: "Cliquez ici si vous souhaitez payer l'intégralité de votre commande en utilisant une traite bancaire ou une carte de crédit / débit."
                },
                lease: {
                    title: "Bail",
                    desc1: "Paiement mensuel estimé (bail de 36 mois)",
                    desc2: "Services mensuels récurrents",
                    note: "Cliquez ici si vous souhaitez faire une demande de location en vue d'acheter des articles éligibles dans votre commande."
                }
            }
        },
        rentalMessage: "Location non disponible avec l'article de location dans le panier"
    },
    leaseApplication: {
        title: "Soumettez votre demande de bail",
        wizard: {
            steps: {
                zero: {
                    title: "Créer un compte"
                },
                one: {
                    title: "Demande de Bail"
                }
            }
        },
        paragraphs: {
            one: {
                header: "Soumettre une demande de bail",
                description1: "Click sur",
                description2: "Appliquer pour un bail",
                description3: "ci-dessous pour traiter votre demande de bail. Suivez les instructions du formulaire DocuSign pour compléter et soumettre votre demande de bail."
            },
            two: {
                header: "Si vous êtes approuvé",
                description: "Si vous êtes approuvé pour le bail, vous recevrez un email avec votre code d'approbation personnel. Lorsque vous recevez votre code d'approbation, retournez dans le Velocitor Store, ouvrez votre panier, cliquez sur l'option Location et entrez votre code d'approbation pour traiter votre commande."
            },
            three: {
                header: "Si on vous refuse",
                description: "Si le bail vous est initialement refusé, ne vous inquiétez pas! Vous pouvez fournir des informations supplémentaires pour obtenir l’approbation ou d’autres options de financement. Un représentant de Velocitor vous contactera pour déterminer la meilleure façon de finaliser votre achat."
            }
        },
        applyBtn: "POSTULER UN BAIL U.S.",
        applyBtnCan: "POSTULER UN BAIL CANADIEN"
    },
    checkout: {
        title: "Caisse",
        summary: {
            payInFull: {
                subTotal: "Sous-total du panier",
                taxes: "Taxes",
                fee: "Frais de carte bancaire",
                total: "Total de la commande",
                taxStatement: "Les taxes et frais applicables seront facturés sur facture"
            },
            recurring: {
                subTotal: "Sous-total des services mensuels récurrents",
                total: "Services mensuels récurrents"
            },
            lease: {
                message: "Paiement mensuel estimé (bail de 36 mois)"
            }
        },
        wizard: {
            steps: {
                zero: {
                    title: "Créer un compte",
                    message1: "Créer un compte de magasin",
                    message2: "Vous devez d'abord créer un compte de magasin. Entrez les informations requises dans le formulaire ci-dessous et cliquez sur Suivant. En créant un compte, tous les articles de votre panier seront sauvegardés."
                },
                one: {
                    title: "Adresse de facturation",
                    sameAsShipping: "Envoyer à la même adresse"
                },
                two: {
                    title: "Adresse de livraison"
                },
                three: {
                    title: "Méthode d'envoi"
                },
                four: {
                    title: "Mode de paiement",
                    message: "Que vous achetiez intégralement maintenant ou que vous choisissiez de louer, Velocitor exige un mode de paiement enregistré pour les frais mensuels récurrents. Vous pouvez modifier ce mode de paiement à tout moment après l'achat initial en contactant le Velocitor Support Desk.",
                    agreement: "En cochant la ou les cases appropriées ci-dessous et en procédant à l'achat ou à la location des articles de mon panier, je reconnais, accepte et consens à ce qui suit:",
                    agreementPdfName: "Contrat de services de support logiciel et de dépôt Velocitor",
                    productAgreementPdfName: "Contrat d'abonnement aux services V-Track-VEDR",
                    rentalAgreementPdfName: "Contrat de services de location"
                }
            }
        }
    },
    orderConfirmation: {
        title: "Confirmation de commande",
        printOrder: "Ordre d'impression",
        invoiceCredentials: {
            billing: {
                title: "Détails de facturation"
            },
            shipping: {
                title: "Détails de la livraison",
                shippingMethod: "Méthode d'envoi"
            },
            payment: {
                paymentMethod: "Méthode De Paiement",
                referenceNumber: "Numéro De Référence"
            }
        },
        invoiceSummary: {
            orderNumber: "Commande N °",
            orderDate: "Date de commande",
            orderTotal: "Total de la commande"
        },
        items: {
            header: {
                description: "Description",
                price: "Prix",
                quantity: "Quantité",
                total: "Total",
                recurring: "Postes Mensuels Récurrents"
            },
            footer: {
                subTotal: "Sous-Total",
                shipping: "Envoi",
                fee: "Frais de carte bancaire",
                taxes: "Taxation",
                taxStatement: "Les taxes et frais applicables seront facturés sur facture",
                total: "Total",
                recurring: "Frais Mensuels"
            }
        }
    },
    footer: {
        services: "Services",
        support: "Soutien",
        buyingGuide: "Guide d'achat"
    },
    guestAlert: {
        desc1: "Pour enregistrer les articles ajoutés à votre panier, veuillez",
        desc2: "créez un compte"
    },
    account: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        company: "Compagnie",
        email: "Email",
        phoneNumber: "Numéro de téléphone",
        password: "Mot de passe",
        confirmPassword: "Confirmer Le Mot De Passe",
        station: "Station",
        contractNumber: "Numéro De Contrat",
        employeeId: "FedEx Ground ID",
        purchaseEligibilityDate: "Date D'Admissibilité À L'Achat",
        onTheRoadEligibilityDate: "Sur La Route Date D'Admissibilité"
    },
    profile: {
        info: {
            title: "Informations Sur Le Client",
            save: "Enregistrer Le Profil"
        },
        addresses: {
            title: "Adresse"
        },
        orders: {
            title: "Ordre",
            details: "Détail",
            orderStatus: "Statut De La Commande",
            orderNumber: "Numéro De Commande",
            orderDate: "Date De Commande",
            orderTotal: "Total De La Commande",
            orderRecurringTotal: "Commander Des Frais Récurrents"
        },
        changePassword: {
            title: "Changer De Mot De Passe",
            oldPassword: "Ancien Mot De Passe",
            newPassword: "Nouveau Mot De Passe",
            confirmPassword: "Confirmer Le Mot De Passe",
            save: "Changer De Mot De Passe"
        }
    },
    address: {
        add: "Ajoutez l'adresse",
        edit: "Modifier L'Adresse",
        address1: "Adresse 1",
        address2: "Adresse 2",
        city: "Ville",
        state: "État",
        country: "Pays",
        postalCode: "Code postal"
    },
    bankAccount: {
        title: "Chèque De Banque",
        routingNumber: "Numéro de routage",
        accountNumber: "Numéro de compte",
        name: "Le nom sur le compte",
        type: "Type de compte",
        typeOptions: {
            checking: "Courant",
            savings: "Épargne"
        }
    },
    creditCard: {
        title: "Carte De Crédit / Débit",
        cardNumber: "Numéro De Carte",
        code: "Code De La Carte",
        expMonth: "Mois d'expiration",
        expYear: "Année d'expiration",
        name: "Nom Du Titulaire",
        type: "Type De Carte"
    },
    lease: {
        title: "Bail"
    },
    support: {
        title: "Contacter le support commercial",
        options: {
            title: "Options de support aux ventes"
        },
        chat: "Chattez en direct avec un agent commercial Velocitor",
        phone: "Contacter un agent commercial Velocitor par téléphone",
        email: "Envoyez un courrier électronique au Velocitor Sales Desk pour obtenir de l'aide"
    },
    modals: {
        alreadyApproved: {
            cartReady: {
                title: "Mon panier est prêt ...",
                description: "Cliquez sur \"Aller au panier\" ci-dessous, naviguez jusqu'au bas du panier et sélectionnez l'option Location. Entrez votre code d'approbation lorsque vous y êtes invité et suivez les instructions à l'écran pour effectuer votre achat.",
                btn: "Aller au panier"
            },
            continueShopping: {
                title: "Je n'ai pas encore construit mon panier ...",
                description: "Cliquez sur \"Commencer vos achats\" ci-dessous pour revenir à la page d'accueil et parcourir les différentes options de notre magasin. Ajoutez des articles à votre panier au besoin. Une fois vos achats terminés, ouvrez votre panier, naviguez au bas de la page et sélectionnez l'option Location. Entrez votre code d'approbation lorsque vous y êtes invité et suivez les instructions à l'écran pour effectuer votre achat.",
                btn: "Commencer vos achats"
            }
        },
        eligibility: {
            title: "Merci de visiter le magasin Velocitor.",
            station: "Station éligible",
            purchaseEligibility: "Admissibilité à l'achat",
            onTheRoadEligibility: "Go Live Admissibilité",
            desc1: "Respectez vos normes contractuelles FedEx Ground et révolutionnez votre façon de faire des affaires.",
            desc21: "Velocitor Solutions est le",
            desc22: "seul guichet unique",
            desc23: "pour les fournisseurs de services FedEx Ground.",
            list: {
                starV: "Fournisseur STAR V approuvé par FedEx",
                vedr: "Fournisseur VEDR approuvé par FedEx",
                telematics: "Fournisseur de solutions télématiques approuvé par FedEx"
            },
            dontShow: "Ne montre plus cela",
            continueShopping: "Continuer vos achats"
        },
        lease: {
            approvalCode: {
                title1: "Avoir un code d'approbation?",
                title2: "Entrez votre code d'approbation de bail",
                approvalCode: "Code d'approbation de bail",
                btn: "Soumettre",
                desc1: "Même si vous avez choisi de louer tout ou partie des articles éligibles de votre commande, Velocitor requiert la saisie d’informations de facturation, d’expédition et de paiement pour traiter correctement votre commande une fois approuvée par la société de leasing et pour les frais récurrents mensuels. Vous pouvez modifier ces informations à tout moment après l'achat initial en contactant le Velocitor Support Desk.",
                desc2: "Si vous avez déjà fait une demande de location et avez reçu un code d'approbation, entrez ce code dans la case ci-dessus et cliquez sur le bouton Soumettre pour traiter votre commande."
            },
            leaseApplication: {
                title: "Demander un bail",
                step: "Étape %{number}",
                steps: {
                    one: {
                        description: "Créer un compte de magasin (si ce n'est déjà un client)"
                    },
                    two: {
                        description: "Remplir la demande de location"
                    }
                },
                btn: "Commencer"
            }
        },
        wizardInProgress: {
            title: "Les modifications de votre panier seront perdues. Voulez-vous continuer?",
            yes: "Oui",
            no: "Non"
        },
        chatSoon: {
            title: "Fonction de chat en direct à venir"
        }
    },
    attributes: {
        homeOfficeChargingAccessories: "Accessoires de charge pour maison / bureau",
        vehicleChargingAccessories: "Accessoires de charge de véhicule",
        holsters: "Holsters",
        miscellaneousAccessories: "Accessoires divers",
        rogersDataPlans: "Forfaits de données Rogers"
    },
    specifications: {},
    misc: {
        month: "Mois",
        learnMore: "Apprendre encore plus",
        select: "Sélectionner",
        chooseDevice: "Choisissez un appareil",
        selectForKit: "Sélectionner pour kit",
        details: "Détails",
        partNumber: "Numéro d'article",
        buyNow: "Acheter Maintenant",
        addToCart: "Ajouter au panier",
        subTotal: "Subtotal",
        shipping: "Envoi",
        newAddress: "Nouvelle adresse",
        device: "Dispositif",
        specifications: "%{name} Spécifications",
        shop: "Boutique",
        chat: "Bavarder",
        liveChat: "Chat en direct",
        phone: "Téléphone",
        email: "Email",
        step: "Étape",
        previous: "Précédent",
        next: "Suivant",
        finish: "Terminer",
        complete: "Achevé",
        edit: "Modifier",
        delete: "Supprimer",
        hours: "Heures",
        salesHours: "Du lundi au samedi de 7h à 22h",
        inStock: "En Stock",
        outOfStock: "En Rupture de Stock",
        availability: "Disponibilité"
    },
    abbreviations: {
        quantity: "qté"
    },
    alerts: {
        quantity: "Entrez une quantité",
        addedToCart: "(%{quantity}) %{name} a été ajouté au panier",
        paymentError: "Une erreur s'est produite lors du traitement du paiement. Veuillez contacter le support pour obtenir de l'aide.",
        genericError: "Il y avait une erreur. Contactez votre administrateur pour obtenir de l'aide."
    },
    validation: {
        login: {
            contractNumber: {
                required: "Entrez votre numéro de contrat"
            },
            employeeId: {
                required: "Entrez votre identifiant FedEx Ground"
            },
            username: {
                required: "Entrez votre adresse email"
            },
            password: {
                required: "Tapez votre mot de passe"
            }
        },
        passwordRecovery: {
            email: {
                required: "Entrez votre adresse email",
                email: "Adresse e-mail invalide"
            }
        },
        passwordReset: {
            password: {
                required: "Tapez votre mot de passe"
            },
            confirmPassword: {
                required: "Confirmer votre mot de passe",
                match: "Confirmer que le mot de passe ne correspond pas"
            }
        },
        account: {
            firstName: {
                required: "Entrez votre prénom"
            },
            lastName: {
                required: "Entrez votre nom de famille"
            },
            company: {
                required: "Entrez le nom de votre entreprise"
            },
            email: {
                required: "Entrez votre adresse email",
                email: "Adresse e-mail invalide"
            },
            phoneNumber: {
                required: "Entrez votre numéro de téléphone",
                number: "Numéro de téléphone invalide, doit comporter 10 chiffres"
            },
            password: {
                required: "Tapez votre mot de passe"
            },
            confirmPassword: {
                required: "Confirmer votre mot de passe",
                match: "Confirmer que le mot de passe ne correspond pas"
            }
        },
        address: {
            address1: {
                required: "Entrez votre adresse"
            },
            address2: {
                noPoundSign: "Ce champ ne peut pas contenir le symbole '#'"
            },
            city: {
                required: "Entrez votre nom de ville"
            },
            state: {
                required: "Choisissez votre état"
            },
            country: {
                required: "Choisis ton pays"
            },
            postalCode: {
                required: "Entrez votre code postal"
            }
        },
        bankAccount: {
            routingNumber: {
                required: "Entrez votre numéro de routage"
            },
            accountNumber: {
                required: "Entrez votre numéro de compte"
            },
            name: {
                required: "Entrez le nom du compte"
            },
            type: {
                required: "Choisissez un type de compte"
            },
            terms: {
                required: "Vous devez cocher la case Accusé de réception de l'accord de services avant de poursuivre."
            }
        },
        creditCard: {
            cardNumber: {
                required: "Entrez votre numéro de carte"
            },
            code: {
                required: "Entrez votre code de carte"
            },
            expMonth: {
                required: "Choisissez un mois d'expiration"
            },
            expYear: {
                required: "Choisissez une année d'expiration"
            },
            name: {
                required: "Entrez le nom du titulaire tel qu'il apparaît sur la carte"
            }
        },
        profile: {
            changePassword: {
                oldPassword: {
                    required: "Entrez votre ancien mot de passe"
                },
                newPassword: {
                    required: "Entrez votre nouveau mot de passe"
                },
                confirmNewPassword: {
                    required: "Confirmer votre nouveau mot de passe",
                    match: "Confirmer que le mot de passe ne correspond pas"
                }
            }
        }
    },
    locale: {
        date: {
            short: "D/M/YYYY",
            long1: "D MMM, YYYY",
            long2: "D MMMM, YYYY"
        }
    }
};